export const HELP_ARTICLE_UI_COPY_HI = {
  "onThisPage": "इस पेज पर",
  "jumpMessage": "निर्यात से पहले आपको सटीक वर्कफ़्लो प्रश्न का उत्तर देना होगा।",
  "faq": "अक्सर पूछे जाने वाले प्रश्न",
  "by": "द्वारा",
  "lastReviewed": "अंतिम बार समीक्षा की गई"
};

export const COOKIE_CONSENT_COPY_HI = {
  "text": "हम आवश्यक कार्यक्षमता, विश्लेषण और विज्ञापन माप (Google और मेटा) के लिए कुकीज़ और समान तकनीकों का उपयोग करते हैं।",
  "detail": "यदि आप अस्वीकार करते हैं, तो वैकल्पिक विश्लेषण और विज्ञापन माप बंद रहेंगे। हमारी गोपनीयता सूचना में और जानें।",
  "manage": "कुकी सेटिंग्स",
  "save": "प्राथमिकताएँ सहेजें",
  "essentialTitle": "आवश्यक कुकीज़",
  "essentialDesc": "सुरक्षा, लॉगिन और मुख्य साइट कार्यक्षमता के लिए आवश्यक है।",
  "analyticsTitle": "विश्लेषिकी कुकीज़",
  "analyticsDesc": "ट्रैफ़िक और उत्पाद उपयोग (उदाहरण के लिए Google Analytics) को समझने में हमारी सहायता करें।",
  "advertisingTitle": "विज्ञापन मापन",
  "advertisingDesc": "विज्ञापन प्रदर्शन और रूपांतरण मापें (उदाहरण के लिए मेटा पिक्सेल/CAPI)।",
  "gpcNotice": "आपके ब्राउज़र में वैश्विक गोपनीयता नियंत्रण सक्षम है, इसलिए विज्ञापन मापन बंद रहता है।",
  "saveError": "हम इस ब्राउज़र में आपकी कुकी प्राथमिकताओं को सहेज नहीं सके। अपनी संग्रहण या गोपनीयता सेटिंग जांचें और पुनः प्रयास करें।",
  "accept": "सभी को स्वीकार करें",
  "reject": "वैकल्पिक अस्वीकार करें",
  "learnMore": "गोपनीयता सूचना"
};

export const NOT_FOUND_PAGE_COPY_HI = {
  "title": "404 | Stocktag",
  "description": "आप जिस पृष्ठ की तलाश कर रहे हैं वह नहीं मिल सका।",
  "ariaLabel": "पेज नहीं मिला",
  "goHome": "घर जाओ",
  "openStudio": "Metadata Studio खोलें"
};

export const MOBILE_NAV_LABELS_HI = {
  "menu": "मेनू",
  "metadata": "मेटाडाटा",
  "studio": "स्टूडियो",
  "history": "इतिहास",
  "market": "बाज़ार",
  "profile": "प्रोफाइल",
  "login": "लॉग इन करें",
  "navAriaLabel": "मोबाइल नेविगेशन"
};

export const HELP_CENTER_COPY_HI = {
  "onThisPageTitle": "इस पेज पर",
  "onThisPageBody": "सहायता पृष्ठ अब वास्तविक उत्पाद यात्रा का अनुसरण करता है: सेटअप, अपलोड, नियम सेटिंग, समीक्षा, निर्यात और इतिहास।",
  "overviewTitle": "पहली बार उपयोगकर्ता के लिए सही क्रम",
  "overviewBody": "पहले खाता और क्रेडिट सेटअप स्पष्ट करें, फिर फ़ाइलें लाएँ, नियम परिभाषित करें, परिणाम परिष्कृत करें और अंत में निर्यात करें।",
  "overviewCards": [
    {
      "id": "prepare",
      "title": "तैयारी करो",
      "body": "योजना, क्रेडिट और BYOK रणनीति की पुष्टि करें।"
    },
    {
      "id": "produce",
      "title": "उत्पादन",
      "body": "संपत्तियां अपलोड करें, मेटाडेटा नियम परिभाषित करें और आउटपुट को कड़ा करें।"
    },
    {
      "id": "deliver",
      "title": "पहुंचाना",
      "body": "बाज़ारों के लिए निर्यात करें, इतिहास से पुनः डाउनलोड करें और ड्राफ्ट पुनर्प्राप्त करें।"
    }
  ],
  "flowTitle": "चरण-दर-चरण वर्कफ़्लो",
  "flowBody": "प्रत्येक अनुभाग आपके द्वारा उपयोग की जाने वाली स्क्रीन और उस चरण में आपके द्वारा की जा सकने वाली कार्रवाइयों दोनों को दिखाता है।",
  "extraToolsTitle": "मुख्य प्रवाह के बाहर सहायक उपकरण",
  "extraToolsBody": "ये अतिरिक्त मॉड्यूल हैं जिनका उपयोग आप कोर मेटाडेटा वर्कफ़्लो के बाद करते हैं।",
  "resultLabel": "इस चरण का परिणाम",
  "mediaLabel": "स्क्रीन आप यहां देखेंगे",
  "stageSetupLabel": "सेटअप",
  "stageSetupTitle": "अपना कार्यक्षेत्र तैयार करें",
  "stageSetupSummary": "पहले सत्र से पहले खाते की स्थिति और उपलब्ध क्रेडिट की पुष्टि करें।",
  "stageSetupResult": "आप जानते हैं कि आप किस क्रेडिट प्लान और बैलेंस के साथ काम कर रहे हैं।",
  "stageUploadLabel": "अपलोड करें",
  "stageUploadTitle": "स्टूडियो में फ़ाइलें लाएँ",
  "stageUploadSummary": "छवियाँ, वैक्टर और वीडियो आयात करें और कार्य सत्र शुरू करें।",
  "stageUploadResult": "आपका सत्र तैयार है और परिसंपत्तियाँ एक स्पष्ट प्रसंस्करण प्रवाह में प्रवेश करती हैं।",
  "stageRulesLabel": "नियंत्रण",
  "stageRulesTitle": "मेटाडेटा नियमों को परिभाषित करें",
  "stageRulesSummary": "पीढ़ी से पहले शीर्षक, विवरण, कीवर्ड, भाषा और परिसंपत्ति व्यवहार को आकार दें।",
  "stageRulesResult": "आउटपुट सामान्य होना बंद हो जाता है और आपके अपने गुणवत्ता मानक से मेल खाने लगता है।",
  "stageReviewLabel": "परिष्कृत करें",
  "stageReviewTitle": "परिणामों की समीक्षा करें और उन्हें कड़ा करें",
  "stageReviewSummary": "डिलीवरी से पहले जेनरेट किए गए मेटाडेटा को संपादित करें, पुन: उत्पन्न करें और साफ़ करें।",
  "stageReviewResult": "अंत में आपको साफ़-सुथरा, अधिक प्रासंगिक और अधिक रक्षात्मक बाज़ार मेटाडेटा मिलता है।",
  "stageExportLabel": "पहुंचाना",
  "stageExportTitle": "बाज़ारों के लिए निर्यात करें",
  "stageExportSummary": "प्रारूप चुनें, प्रीसेट लागू करें और एक सत्र से कई आउटपुट तैयार करें।",
  "stageExportResult": "आप प्रत्येक प्लेटफ़ॉर्म के लिए तैयार CSV फ़ाइलों या एम्बेडेड मेटाडेटा पैकेजों के साथ निकलते हैं।",
  "stageHistoryLabel": "पुरालेख",
  "stageHistoryTitle": "इतिहास पर लौटें और ड्राफ्ट पुनर्प्राप्त करें",
  "stageHistorySummary": "पुराने निर्यातों को फिर से डाउनलोड करें, ड्राफ्ट पुनर्प्राप्त करें और संग्रह को साफ़ रखें।",
  "stageHistoryResult": "पिछला कार्य सत्रों के बीच नष्ट होने के बजाय पुन: प्रयोज्य रहता है।",
  "supportedFilesTitle": "समर्थित फ़ाइलें",
  "supportedFilesBody": "JPG, PNG, SVG, EPS, MP4, और MOV सभी को एक ही स्टूडियो के अंदर संभाला जा सकता है।",
  "rulesGuardrailsTitle": "नियम और रेलिंग",
  "rulesGuardrailsBody": "एआई आउटपुट को सुरक्षित सीमाओं के अंदर रखने के लिए कस्टम निर्देशों और निषिद्ध शब्दों का उपयोग करें।",
  "rulesAdvancedTitle": "भाषा, मोड और एआई गहराई",
  "rulesAdvancedBody": "अनुवाद, PNG/वेक्टर/ईपीएस मोड और गहन विश्लेषण सेटिंग्स आपको विभिन्न परिसंपत्ति प्रकारों के लिए व्यवहार को समायोजित करने देती हैं।",
  "aiRefineTitle": "एआई शोधन",
  "aiRefineBody": "तर्क, पुनर्जनन और गहन विश्लेषण आपको कमजोर आउटपुट को शीघ्रता से मजबूत करने में मदद करते हैं।",
  "presetCardTitle": "पूर्व निर्धारित तर्क",
  "presetCardBody": "एक ही मेटाडेटा सेट को विभिन्न बाज़ार अपेक्षाओं के लिए दोबारा आकार दिया जा सकता है।",
  "extraToolsNavLabel": "अतिरिक्त उपकरण"
};

export const SUPPORT_COPY_HI = {
  "helpEyebrow": "समर्थन केंद्र",
  "helpTitle": "उत्तर के लिए सबसे तेज़ मार्ग चुनें",
  "helpBody": "त्वरित मार्गदर्शन के लिए सहायक का उपयोग करें, निजी या खाता-विशिष्ट सहायता के लिए किसी वास्तविक व्यक्ति को ईमेल करें, और उत्पाद विचारों को फीडबैक बोर्ड पर दृश्यमान रखें।",
  "feedbackEyebrow": "सही चैनल, तेज़ प्रतिक्रिया",
  "feedbackTitle": "फीडबैक और समर्थन के अलग-अलग काम हैं",
  "feedbackBody": "उत्पाद विचारों को सार्वजनिक रूप से पोस्ट करें ताकि अन्य लोग भी इसमें शामिल हो सकें। निजी, बिलिंग, खाता, या ब्लॉकिंग मुद्दों को सीधे सहायता टीम को भेजें।",
  "aiTitle": "एआई सहायक से पूछें",
  "aiBody": "वर्कफ़्लो, सेटिंग्स, निर्यात और क्रेडिट के बारे में तुरंत उत्तर प्राप्त करें।",
  "aiAction": "सहायक खोलें",
  "humanTitle": "किसी वास्तविक व्यक्ति से बात करें",
  "humanBody": "खाता, बिलिंग, सुरक्षा, निजी या अनसुलझे मुद्दों के लिए ईमेल का उपयोग करें।",
  "humanAction": "मानव सहायता ईमेल करें",
  "feedbackCardTitle": "एक उत्पाद विचार साझा करें",
  "feedbackBodyCard": "एक सार्वजनिक अनुरोध प्रारंभ करें, उसकी स्थिति का अनुसरण करें और चर्चा जारी रखें।",
  "feedbackAction": "फीडबैक बोर्ड खोलें",
  "helpCardTitle": "सहायता केंद्र पढ़ें",
  "helpCardBody": "अनुरोध खोलने से पहले निर्देशित वर्कफ़्लो और सामान्य उत्तरों की जाँच करें।",
  "helpCardAction": "सहायता केंद्र खोलें",
  "privacyNote": "फीडबैक बोर्ड सार्वजनिक है. कभी भी API कुंजी, भुगतान विवरण, व्यक्तिगत डेटा या निजी खाता जानकारी पोस्ट न करें।",
  "launcherLabel": "समर्थन",
  "chatbotTitle": "Stocktag समर्थन",
  "chatbotStatus": "एआई सहायक · मानव सहायता उपलब्ध",
  "chatbotHumanStatus": "सहायता टीम इस बातचीत को संभाल रही है",
  "chatbotHumanQueuedNotice": "नए संदेश समर्थन कतार में सहेजे जाते हैं. टीम के उत्तर यहां दिखाई देंगे.",
  "chatbotAdminSender": "सहायता टीम",
  "chatbotAiSender": "एआई सहायक",
  "humanPromptTitle": "एक वास्तविक व्यक्ति की आवश्यकता है?",
  "humanPromptBody": "Stocktag टीम को ईमेल करें और अपने ड्राफ्ट में वर्तमान चैट संदर्भ शामिल करें।",
  "chatbotHumanAction": "ईमेल समर्थन",
  "chatbotFeedbackAction": "प्रतिक्रिया साझा करें",
  "chatbotHelpAction": "सहायता केंद्र",
  "chatbotFooterNote": "चैट अधिकृत सहायक कर्मचारियों को दिखाई देती हैं, जो जरूरत पड़ने पर यहां जवाब दे सकते हैं।",
  "chatbotPrivacyNotice": "चैट संदेश Stocktag सर्वर पर संग्रहीत होते हैं और अधिकृत सहायक कर्मचारियों द्वारा उनकी समीक्षा और उत्तर दिया जा सकता है। पासवर्ड, API कुंजी, कार्ड विवरण या संवेदनशील व्यक्तिगत डेटा साझा न करें।",
  "chatbotPrivacyAction": "गोपनीयता",
  "chatbotSources": "संबंधित सत्यापित उत्तर",
  "chatbotResolvedPrompt": "क्या इससे समस्या हल हो गई?",
  "chatbotResolvedYes": "हाँ, समाधान हो गया",
  "chatbotResolvedNo": "नहीं, निदान जारी रखें",
  "chatbotResolvedThanks": "धन्यवाद - संकल्प नोट किया गया।",
  "chatbotContinuing": "अगले निदान चरण के साथ जारी रखें...",
  "chatPromptHelp": "मेरे प्रश्न के लिए सही Stocktag वर्कफ़्लो चुनने में मेरी सहायता करें।",
  "chatPromptFeedback": "मेरे उत्पाद विचार को स्पष्ट, उपयोगी फीडबैक में बदलने में मेरी सहायता करें।",
  "emailSubject": "Stocktag समर्थन अनुरोध",
  "emailIntro": "मुझे Stocktag सहायता टीम से सहायता चाहिए.",
  "emailSummary": "कृपया नीचे दिए गए अनुरोध में मेरी सहायता करें।",
  "escalationSubject": "Stocktag समर्थन - चैट एस्केलेशन",
  "escalationIntro": "मैंने Stocktag AI असिस्टेंट के साथ शुरुआत की और अब एक वास्तविक व्यक्ति से मदद चाहूंगा।",
  "escalationSummary": "कृपया इस समर्थन अनुरोध को जारी रखें।",
  "bugNoticeTitle": "क्या यह अवरोधन कार्य है या आपके खाते से संबंधित है?",
  "bugNoticeBody": "अत्यावश्यक, निजी, बिलिंग या खाता समस्याओं के लिए, ईमेल सहायता भी। संवेदनशील विवरण सार्वजनिक रूप से पोस्ट न करें.",
  "bugNoticeAction": "मानव सहायता ईमेल करें",
  "socialTitle": "आधिकारिक Stocktag सामाजिक पेज",
  "socialBody": "घोषणाओं और सार्वजनिक संपर्क के लिए इन पृष्ठों का उपयोग करें। इसके बजाय निजी खाता, बिलिंग, सुरक्षा, या भुगतान संदर्भ ईमेल द्वारा भेजें।"
};


export default HELP_CENTER_COPY_HI;
